// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__J961q","large":"styles_large__1fpqg"};